import { atom } from 'recoil';

import * as K from 'common/constants';
import { PageAlertConfig } from 'components/common/PageAlert/PageAlert.types';

export const pageAlertConfigState = atom<PageAlertConfig>({
  key: K.RECOIL_ATOM_KEY.PAGE_ALERT_CONFIG,
  default: K.NO_PAGE_ALERT,
});
